import { render, staticRenderFns } from "./CoreHRIndex.vue?vue&type=template&id=ccddd692"
import script from "./CoreHRIndex.vue?vue&type=script&lang=js"
export * from "./CoreHRIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports